/**
 * Validates the length of input.
 * The input is valid is the length is greater than zero.
 * The input is valid is the length is less than or equal to given maximum length.
 *
 * @param {string} input - text value from input
 * @param {number} maxLength - maximum allowed character length
 * @returns [{boolean}, {string}] - Array with the validation result.
 * A boolean that indicates wether the input is valid and a string with the error message.
 */

import { FormValidationErrorMessages } from '../enums';

export default function validateCharLength(input, maxLength) {
  if (input?.trim().length === 0) {
    return [false, FormValidationErrorMessages.EMPTY];
  }

  if (input?.trim().length > maxLength) {
    return [false, FormValidationErrorMessages.MAX_LENGTH];
  }

  return [true, ''];
}
